import { SandboxedIframe } from "@/components/sandboxed-iframe";
import { FlowComponentHeader } from "@/components/ui/flow-component-header";
import { useT } from "@/lib/i18n/use-t";
import type { IframeConfig } from "@/lib/types/flow";
import { T } from "./iframe-renderer.i18n";

type IframeRendererProps = {
  config: IframeConfig;
};

/** QL-776: a third-party page by https URL — never built from author-supplied HTML. */
export function IframeRenderer({ config }: IframeRendererProps) {
  const t = useT(T);
  if (!config?.url) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm text-muted-foreground">{t.noUrl}</p>
      </div>
    );
  }

  // Same style vocabulary as the embed component: none / border / box.
  const wrapperClass =
    config.style === "border"
      ? "border rounded-lg p-4"
      : config.style === "box"
        ? "bg-muted/30 rounded-lg p-4"
        : "";

  const hasHeader = Boolean(config.title || config.description);

  return (
    <div className={wrapperClass}>
      {hasHeader && (
        <FlowComponentHeader
          title={config.title}
          description={config.description}
          className="mb-4"
        />
      )}
      <SandboxedIframe
        url={config.url}
        title={config.title}
        height={config.height}
        aspectRatio={config.aspectRatio}
      />
    </div>
  );
}
